import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorSubject } from '../subject/error.subject';
import { ResponseDto } from '../dto/response.dto';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router, private errorSubject: ErrorSubject) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) => {
                const responseDto: ResponseDto = this.handleError(err);
                console.error('Error capturado por el interceptor:', responseDto);

                // Guardar el error en ErrorSubject
                this.errorSubject.saveErrorData(responseDto);

                // Devolver el error transformado
                return throwError(() => responseDto);
            })
        );
    }

    // Maneja todos los tipos de errores
    private handleError(err: HttpErrorResponse): ResponseDto {
        if (err.status === 0) {
            // Error por falta de conexión o servicios no disponibles
            return this.createResponseDto(
                'Los servicios no están disponibles, intenta más tarde.',
                '503',
                '503'
            );
        }

        if (err.status === 400) {
            // Errores 400 (Bad Request), verifica que el formato del error sea el esperado
            return this.createResponseDto(
                err.error?.errorDetail || 'Solicitud inválida.',
                err.error?.statusCode || '400',
                '400'
            );
        }

        if (err.status === 403) {
            // Error 403 (Forbidden)
            return this.createResponseDto(
                'No tienes permisos para realizar esta acción.',
                '403',
                '403'
            );
        }

        if (err.status === 500) {
            // Error 500 (Internal Server Error)
            return this.createResponseDto(
                'Error en el servidor, intenta más tarde.',
                '500',
                '500'
            );
        }

        // Para cualquier otro tipo de error no manejado específicamente
        return this.createResponseDto(
            err.message || 'Error desconocido.',
            err.status.toString(),
            err.status.toString()
        );
    }

    // Helper para crear ResponseDto
    private createResponseDto(errorDetail: string, statusCode: string, httpStatus: string): ResponseDto {
        return {
            errorDetail,
            response: '',  // Puedes pasar datos adicionales aquí si es necesario
            statusCode,
            httpStatus
        };
    }
}
